module.exports = __webpack_public_path__ + "static/media/asn.72ef314d.png";